/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { planDataTierSchema } from './PlanDataTierSchema'

export const planDataSchema = z.object({
	tier: planDataTierSchema,
	selfServe: z.boolean(),
	monthly: z.object({ id: z.string(), amount: z.number(), currency: z.string() }).nullable(),
	yearly: z.object({ id: z.string(), amount: z.number(), currency: z.string() }).nullable(),
	trialDays: z.number().nullable(),
})

export type PlanDataSchema = z.infer<typeof planDataSchema>
